<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kampagne bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.campaigns.update', campaign))">
                <form-fields :form="form" :campaign="campaign" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'campaign',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.campaign.name,
                    description: this.campaign.description,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>